export default function setImageUploadErrorAction(imageUploadError) {
    return {
        type: 'SET_IMAGE_UPLOAD_ERROR',
        payload: imageUploadError
    }
}